import type { PlannedMeeting } from "@acto/ambient-context-schema";
import type Meeting from "@acto/taskpane/core/domain/Meeting";
import { capList, toIsoDate } from "./helpers";

const toAddress = (street: string | undefined, city: string | undefined): string | undefined =>
  [street, city].filter(Boolean).join(" · ") || undefined;

/** Meetings of a day/list → schema planned meetings, in render order. */
export function meetingsToPlannedMeetings(
  meetings: Meeting[] | undefined,
  { limit }: { limit?: number } = {},
): PlannedMeeting[] {
  return capList(meetings ?? [], limit).map((m) => ({
    date: toIsoDate(m.scheduledDate),
    start_time: m.scheduledStartTime ?? undefined,
    end_time: m.scheduledEndTime ?? undefined,
    customer_external_reference: m.customer.externalReference,
    customer_name: m.customer.name,
    address: toAddress(m.customer.street, m.customer.city),
    recurring: m.series ? true : undefined,
  }));
}
